import React from "react";
import QuickActionPopup, { QuickActionPopupProps } from "../../quick-action-popup/QuickActionPopup";
import InfoIcon from "@vahak/core/dist/icons/info_grey.svg";
import TextLabelAndValue from "../ticket-system/common/TextLabelAndValue/TextLabelAndValue";
import { formatDate, toValidDate } from "@vahak/core-ui/dist/methods";
import { PartialPick } from "@vahak/core-ui/dist/types";
import { AutoAssignInfo } from "../../../services/load/useGetLoadMarketV2/type";
import { VerticalFlex } from "@vahak/core-ui/dist/layout/Flex";
import TextCTA from "@vahak/core-ui/dist/components/TextCTA";

interface UnassigmentInfoProps extends PartialPick<QuickActionPopupProps, "isOpen" | "onToggle"> {
    data?: AutoAssignInfo;
}

const UnassigmentInfo = ({ isOpen, onToggle, data }: UnassigmentInfoProps) => {
    return (
        <>
            {!!data?.unassignment_data?.length && (
                <TextCTA onClick={onToggle}>
                    <InfoIcon />
                </TextCTA>
            )}
            <QuickActionPopup
                titleText="Unassignment Reasons"
                isOpen={isOpen}
                onToggle={onToggle}
                description={
                    <VerticalFlex>
                        {data?.unassignment_data?.map((dt) => {
                            return (
                                <TextLabelAndValue
                                    label={formatDate(toValidDate(1000 * dt?.attempted_at!), "YYYY-MM-DD hh:mm a")}
                                    value={dt?.unassignment_reasons}
                                />
                            );
                        })}
                    </VerticalFlex>
                }
            />
        </>
    );
};

export default UnassigmentInfo;
